import { render, staticRenderFns } from "./mobileMyGift.vue?vue&type=template&id=8e9730c2&scoped=true&"
import script from "./mobileMyGift.vue?vue&type=script&lang=js&"
export * from "./mobileMyGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9730c2",
  null
  
)

export default component.exports